import { CONTACTS_URL, LABEL_URL } from "../../../services/common-urls";
import { MHTTPCL, JSON_STRING } from "../../../services/http/http-client";

export const ProjectsService = {
  getProjects: () =>
    MHTTPCL.get(LABEL_URL, {
      section: "projects",
      action: "",
      output: JSON_STRING
    }),
  createProject: () =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "create_project",
      output: JSON_STRING
    }),
  addProject: (project_name, status) =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "new_project",
      project_name,
      status
    }),
  removeProject: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "remove_project",
      project_id
    }),
  searchProjectList: search =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "search_projects",
      search,
      tableID: "projectsTable",
      output: JSON_STRING
    }),
  fetchProjectDetails: project_id =>
    MHTTPCL.get(LABEL_URL, {
      section: "projects",
      action: "project_details",
      project_id,
      output: JSON_STRING
    }),
  fetchProjectOverviewSetupTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "project_details_setup_tab",
      project_id
    }),
  fetchRelatedContacts: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "project_related_contacts",
      project_id,
      output: JSON_STRING
    }),
  deleteContactRelation: contact_relation_id =>
    MHTTPCL.post(CONTACTS_URL, {
      action: "delete_relation",
      contact_relation_id
    }),
  fetchSalesPlanningPhyTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "sales_planning_phy_tab",
      project_id
    }),
  fetchSalesPlanningDigitalTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "sales_planning_digital_tab",
      project_id
    }),
  fetchBudgetTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "budget_tab",
      project_id
    }),
  costTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "cost_tab",
      project_id
    }),
  searchCosts: ({
    project_id,
    start = 0,
    cost_group_id = "",
    marketing_type_id = "",
    date_start = "",
    date_end = ""
  }) =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "search_cost",
      project_id,
      start,
      cost_group_id,
      marketing_type_id,
      date_start,
      date_end
    }),
  calculationTab: project_id =>
    MHTTPCL.post(LABEL_URL, {
      section: "projects",
      action: "project_calculation_tab",
      project_id
    }),
  getProjectLinesByFileId: file_id =>
    MHTTPCL.post(LABEL_URL, {
      file_id,
      output: "json"
    })
};

// searchCosts: ({
//   search = "",
//   cost_group_id = "",
//   status_color = "",
// }, options) => HttpClient.post(ACCOUNTING_URL, {
//   section: ACCOUNTING_COST_SECTION,
//   action: 'search_costs',
//   search,
//   cost_group_id,
//   status_color
// }, options),
